<template>
  <component
    :is="dynamicModal.component"
    v-for="dynamicModal in dynamicModals"
    :key="dynamicModal.component"
    v-bind="dynamicModal.attrs"
  />
</template>

<script setup lang="ts">
import { dynamicModals } from './_composables/use-dynamic-modal';
</script>
